// extracted by mini-css-extract-plugin
export default {"Container":"boxList__Container__VCSJD","ContentBox":"boxList__ContentBox__bA66f"};